import { render, staticRenderFns } from "./LinkView.vue?vue&type=template&id=32de34a4"
import script from "./LinkView.vue?vue&type=script&lang=js"
export * from "./LinkView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports